export const reduxKey = '@@ArtBrandedPopup';

//# sourceMappingURL=constants.js.map